import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';
import { AlertTriangle } from 'lucide-react';

export function ZyCommonErrorNodeView(props: ReactNodeViewProps) {
    const { selected, decorations } = props;

    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div
                className={`my-4 overflow-hidden rounded-lg border-2 ${
                    selected
                        ? 'border-blue-500 ring-2 ring-blue-500 ring-offset-2 dark:ring-offset-gray-900'
                        : 'border-gray-200 dark:border-gray-700'
                } bg-white dark:bg-gray-900`}
            >
                {/* Header */}
                <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-3 dark:border-gray-700 dark:bg-gray-800">
                    <div className="flex items-center gap-3">
                        <AlertTriangle className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                        <span className="text-xs font-semibold tracking-wider text-gray-600 uppercase dark:text-gray-400">
                            zyCommonError
                        </span>
                    </div>
                </div>

                {/* Content Area */}
                <div className="m-6">
                    <NodeViewContent />
                </div>
            </div>
        </ZyNodeViewWrapper>
    );
}
